<div class="col mobile:row mobile:flex-row justify-between text-body-text-regular">
  @if (routerLink()) {
    <a [routerLink]="routerLink()">
      <span class="text-body-text-regular">{{ title() }}</span>
    </a>
  } @else {
    <span>{{ title() }}</span>
  }

  <ng-content />
</div>
